import {
    convertUniversalDateTimeToPersianDateTime,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoButtonSecondary,
    RaikoFlexFirstChildGrowOne, RaikoGridFourColumn,
    RaikoGridOneColumn,
    RaikoGridTwoColumn,
    RaikoLabel,
    RaikoMaterialOutlinedInput,
    RaikoSectionContainer,
    showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import "./SystemLogs.scss"
import {RouteHelper} from "../../route/RouteHelper";
import React, {useEffect, useState} from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {css} from "@emotion/css";

import JSONPretty from 'react-json-pretty';
import 'react-json-pretty/themes/monikai.css';

import {useAuthState} from "../../context/AuthContext";
import {LogsService} from "../../service/logs/LogsService";


export default function SystemLogsDetail() {

    const {fundID} = useAuthState()
    const service = new LogsService()

    const {state: location} = useLocation()
    const {id: logId} = useParams()

    const [pageTitle, setPageTitle] = useState("جزئيات لاگ")
    const navigate = useNavigate()

    useEffect(() => {
        if (location && location.title) {
            setPageTitle(`${location.title} (${logId})`)
        }
    }, [location]);


    useEffect(() => {
        if (fundID && logId)
            getDataFromServer()
    }, [fundID, logId])

    function getDataFromServer() {
        service.getLogDetail(
            fundID,
            logId
        ).then(response => {
            setBefore(response.before)
            setAfter(response.after)
            setDiff(response.diff)

            setDate(convertUniversalDateTimeToPersianDateTime(response.submittedAt))
            setAction(response.action)
            setCategory(response.entityType)
            setUser(response.doBy)

        }).catch(reason => {
            showServerErrorMessage(reason)
        })
    }


    const [user, setUser] = useState("")
    const [action, setAction] = useState("")
    const [category, setCategory] = useState("")
    const [date, setDate] = useState("")

    const [before, setBefore] = useState({})
    const [after, setAfter] = useState({})
    const [diff, setDiff] = useState({})


    return (
        <RaikoBaseContainer>
            <RaikoFlexFirstChildGrowOne>
                <RaikoBreadcrumb className={css`flex-grow: 1;
                    gap: .5rem;`} breadCrumbItems={[
                    raikoBreadCrumbItemGenerator(
                        RouteHelper.LogsList.name,
                        RouteHelper.LogsList.globalUrl
                    ),
                    raikoBreadCrumbItemGenerator(
                        pageTitle,
                        ""
                    )
                ]}/>

                <RaikoButtonSecondary
                    label={"بازگشت"}
                    onClick={_ => {
                        navigate(-1);
                    }}/>
            </RaikoFlexFirstChildGrowOne>


            <RaikoBaseCardContainer>
                <RaikoSectionContainer
                    title={"جزئيات لاگ"}
                >
                    <RaikoGridOneColumn>
                        <RaikoGridFourColumn>
                            <RaikoMaterialOutlinedInput
                                labelText={"کاربر"}
                                value={user}
                                setValue={setUser}
                                disabled
                            />
                            <RaikoMaterialOutlinedInput
                                labelText={"عملیات"}
                                value={action}
                                setValue={setAction}
                                disabled
                            />
                            <RaikoMaterialOutlinedInput
                                labelText={"دسته بندی ها"}
                                value={category}
                                setValue={setCategory}
                                disabled
                            />
                            <RaikoMaterialOutlinedInput
                                labelText={"تاریخ و زمان"}
                                value={date}
                                setValue={setDate}
                                disabled
                            />
                        </RaikoGridFourColumn>
                        <RaikoGridTwoColumn>
                            <RaikoGridOneColumn>
                                <RaikoLabel text={"مقدار قبلی"}/>
                                <div className={css`direction: ltr`}>
                                    <JSONPretty
                                        themeClassName="custom-json-pretty"
                                        id="json-pretty"
                                        mainStyle="padding:1em"
                                        data={before}
                                        valueStyle={'color:#50a14f;'}
                                        stringStyle={'color:#50a14f;'}
                                        keyStyle={'color:#986801'}
                                        booleanStyle={'color:#50a14f;'}
                                        errorStyle={'color:#50a14f;'}
                                    />
                                </div>
                            </RaikoGridOneColumn>

                            <RaikoGridOneColumn>
                                <RaikoLabel text={"مقدار جدید"}/>
                                <div className={css`direction: ltr`}>
                                    <JSONPretty
                                        themeClassName="custom-json-pretty"
                                        id="json-pretty"
                                        mainStyle="padding:1em"
                                        data={after}
                                        valueStyle={'color:#50a14f;'}
                                        stringStyle={'color:#50a14f;'}
                                        keyStyle={'color:#986801'}
                                        booleanStyle={'color:#50a14f;'}
                                        errorStyle={'color:#50a14f;'}
                                    />
                                </div>
                            </RaikoGridOneColumn>

                        </RaikoGridTwoColumn>

                        <RaikoGridOneColumn>
                            <RaikoLabel text={"تفاوت ها"}/>
                            <div className={css`direction: ltr`}>
                                <JSONPretty
                                    themeClassName="custom-json-pretty"
                                    id="json-pretty"
                                    mainStyle="padding:1em"
                                    data={diff}
                                    valueStyle={'color:#50a14f;'}
                                    stringStyle={'color:#50a14f;'}
                                    keyStyle={'color:#986801'}
                                    booleanStyle={'color:#50a14f;'}
                                    errorStyle={'color:#50a14f;'}
                                />
                            </div>
                        </RaikoGridOneColumn>

                    </RaikoGridOneColumn>
                </RaikoSectionContainer>
            </RaikoBaseCardContainer>
        </RaikoBaseContainer>
    )
}